export const ChangePostionInitial = {
  idPosition: -99,
  idBranch: -99,
  reason: "",
};
